export default {
  noActiveCalls: 'No active calls',
  noRecords: 'No records',
};
